module.exports = __webpack_public_path__ + "img/slide-non-dispo-43-es.45288d44.jpg";